import { Box, Button, MenuItem, TextField, useMediaQuery } from "@mui/material";
import MaterialReactTable from "material-react-table";
import { useEffect, useRef, useState } from "react";
import {
  CLOSE_DEAL_DONE_TYPE,
  CLOSE_UNSUCCESSFULL_TYPE,
} from "../../constants/leads";

const LOCAL_STORAGE_KEY = "leads-hidden-columns";

export const LeadTable = ({
  leads,
  isLoading,
  columns,
  onChangeAction,
  setSelectedLeads,
  applyColor,
}) => {
  const [allLeads, setAllLeads] = useState([]); // keep original leads
  const [data, setData] = useState([]); // current table data


  const [columnVisibility, setColumnVisibility] = useState({});

  const tableRef = useRef(null);
  const isMobileScreen = useMediaQuery("(max-width:768px)");

  const leadActions = [{ id: 0, label: "Assign to Another Staff" }];

  const getRowBackgroundColor = (leadStatus) => {
    if (!applyColor) return undefined;

    if (leadStatus === CLOSE_DEAL_DONE_TYPE) {
      return "#d4edda";
    } else if (leadStatus === CLOSE_UNSUCCESSFULL_TYPE) {
      return "#f8d7da";
    } else {
      return "";
    }
  };

  // Load saved column visibility
  useEffect(() => {
    const saved = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (saved) {
      setColumnVisibility(JSON.parse(saved));
    }
  }, []);

  // Sync with incoming leads
  useEffect(() => {
    if (leads) {
      setAllLeads(leads);
      setData(leads); // default: show all leads
    }
  }, [leads]);

  // Show only closed leads
  const handleClosedLeads = () => {
    const closedLeads = allLeads.filter(
      (lead) => lead.leadStatus === 8 || lead.leadStatus === 28
    );
    setData(closedLeads);
  };

  // Reset back to all leads
  const handleShowAll = () => {
    setData(allLeads);
  };

  return (
    <MaterialReactTable
      key={JSON.stringify(columnVisibility)}
      state={{ isLoading: isLoading }}
      tableInstanceRef={tableRef}
      enableStickyHeader={!isMobileScreen}
      muiTableContainerProps={{
        sx: { maxHeight: isMobileScreen ? "100%" : "calc(100vh)" },
      }}
      columns={columns}
      data={data}
      enableRowSelection
      enableDensityToggle={false}
      initialState={{
        density: "compact",
        columnVisibility,
        pagination: { pageSize: 20 },
      }}
      getRowId={(row) => row.leadid}
      onRowSelect={(row) => {
        setSelectedLeads((prevSelected) => [...prevSelected, row.original]);
      }}
      muiTableBodyRowProps={({ row }) => ({
        sx: {
          backgroundColor: getRowBackgroundColor(row.original.leadStatus),
        },
      })}
      renderTopToolbarCustomActions={({ table }) => {
        const selectedLeads = table
          .getSelectedRowModel()
          .flatRows.map((item) => item.original);

        return (
          <Box display="flex" gap={2} alignItems="center">
            <TextField
              select
              variant="outlined"
              size="small"
              sx={{ minWidth: "200px" }}
              label="Action"
              value=""
              onChange={(e) => onChangeAction(e, selectedLeads)}
            >
              {leadActions.map((status) => (
                <MenuItem key={status.id} value={status.id}>
                  {status.label}
                </MenuItem>
              ))}
            </TextField>

            {/* <Button variant="outlined" color="primary" onClick={handleShowAll}>
              Show All
            </Button>

            <Button
              variant="outlined"
              color="primary"
              onClick={handleClosedLeads}
            >
              Closed Leads
            </Button> */}
          </Box>
        );
      }}
      onColumnVisibilityChange={(updater) => {
        const updatedColumnVisibility = updater(columnVisibility);
        localStorage.setItem(
          LOCAL_STORAGE_KEY,
          JSON.stringify(updatedColumnVisibility)
        );
        setColumnVisibility(updatedColumnVisibility);
      }}
    />
  );
};
